import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import CTable from "../../../components/Table/table";
import { getAllGroupsRequest } from "../../../modules/superadmin-modules/groups/Actions";
import { listUnviewedVideosRequest } from "../../../modules/superadmin-modules/reports/Actions";
import { getAllVideosRequest } from "../../../modules/superadmin-modules/videos/Actions";

const VideosAbsentReport = () => {
  const dispatch = useDispatch();
  const [selectedVideoId, setSelectedVideoId] = useState("");
  const [selectedGroupIds, setSelectedGroupIds] = useState([]);
  
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    dispatch(getAllVideosRequest());
    dispatch(getAllGroupsRequest());
  }, [dispatch]);

  const videos = useSelector((state) => state.superadminVideos.videos);
  const groups = useSelector((state) => state.superadminGroups.groups);
  const listUnviewedVideos = useSelector((state) => state.reports.listUnviewedVideos);
  const isLoading = useSelector((state) => state.reports.isLoading);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const videosOptions = videos?.map((data) => {
    return { value: data.id, label: data.title };
  });

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  }) || [];

  const handleGenerateReport = () => {
    if (selectedVideoId) {
      dispatch(listUnviewedVideosRequest(selectedVideoId, selectedGroupIds));
    }
  };

  const viewData = (data) => {
    // Handle row selection if needed
  };

  const Data = listUnviewedVideos?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      student_name: data?.name,
      student_phone: data?.phone,
      mother_phone: data?.mother_phone,
    };
  }) || [];

  const columns = [
    {
      Header: "#",
      accessor: "index",
    },
    {
      Header: "Student Name",
      accessor: "student_name",
    },
    {
      Header: "Phone Number",
      accessor: "student_phone",
    },
    {
      Header: "Parent Phone",
      accessor: "mother_phone",
    },
  ];

  return (
    <Layout>
      <div style={{ minHeight: "400px" }}>
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10"
          flexWrap="wrap"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            Videos Absent Report
          </Text>
          <Flex
            w={{ base: "100%", md: "70%" }}
            justifyContent="space-between"
            alignItems="center"
            gap={2}
          >
            <LogoutMenu />
          </Flex>
        </Flex>

        {/* Filters Section */}
        <Flex
          w="100%"
          my="20px"
          justifyContent="space-between"
          alignItems="end"
          gap={4}
          flexWrap="wrap"
        >
          <Box w={{ base: "100%", md: "30%" }}>
            <Text mb={2} fontWeight="500">Select Video:</Text>
            <Select
              options={videosOptions}
              isMulti={false}
              onChange={(data) => {
                setSelectedVideoId(data?.value || "");
              }}
              styles={colourStyles}
              placeholder="Select Video"
              isClearable
            />
          </Box>

                     <Box w={{ base: "100%", md: "30%" }}>
             <Text mb={2} fontWeight="500">Select Groups (Optional):</Text>
             <Select
               options={groupsOptions}
               isMulti={true}
               value={groupsOptions.filter(option => selectedGroupIds.includes(option.value))}
               onChange={(data) => {
                 const selectedValues = data ? data.map(item => item.value) : [];
                 setSelectedGroupIds(selectedValues);
               }}
               styles={colourStyles}
               placeholder="Select Groups"
               isClearable
             />
           </Box>

          <Box w={{ base: "100%", md: "20%" }}>
            <Button
              colorScheme="blue"
              onClick={handleGenerateReport}
              disabled={!selectedVideoId || isLoading}
              isLoading={isLoading}
              w="100%"
            >
              Generate Report
            </Button>
          </Box>
        </Flex>

        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path={"openModel"}
          Actions={null}
          Title={``}
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar={true}
          noFilter={true}
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar={true}
          isLoading={isLoading}
          perPage={size}
          totalPage={Math.ceil((Data?.length || 0) / size)}
        />
      </div>
    </Layout>
  );
};

export default VideosAbsentReport;
